import { render, staticRenderFns } from "./alert-collections-bar.vue?vue&type=template&id=1bef8df0&scoped=true&"
import script from "./alert-collections-bar.vue?vue&type=script&lang=js&"
export * from "./alert-collections-bar.vue?vue&type=script&lang=js&"
import style0 from "./alert-collections-bar.vue?vue&type=style&index=0&id=1bef8df0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef8df0",
  null
  
)

export default component.exports